import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  // Check if token exists in localStorage
  const token = localStorage.getItem('token');

  // Agar token nahi hai to login page par bhej do
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Agar token hai to dashboard dikha do
  return children;
};

export default ProtectedRoute;
